import { Button, notification, Select, Input, Form, Upload, Card } from "antd"
import Title from "antd/es/typography/Title"
import { GetToolByID, UpdateTool } from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react"
import { Option } from "antd/es/mentions"
const AdminDetailTool = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { id } = useParams();
    const [Tool, setTool] = useState([]);
    const [Edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(false);

    const GetToolID = (id) => {
        console.log(id)
        GetToolByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setTool(res.data)
                let imageFileList = [];
                if (res.data.image) {
                    imageFileList = [{
                        uid: '-1',
                        name: 'image',
                        status: 'done',
                        url: res.data.image
                    }];
                }

                form.setFieldsValue({
                    name: res.data?.name,
                    totalTool: res.data?.totalTool,
                    status: res.data?.status,
                    image: imageFileList
                })
            }
        })
    }

    useEffect(() => {
        GetToolID(id);
    }, [])

    const onFinish = (values) => {
        setLoading(true);
        const imageFile = values.image?.[0]?.originFileObj;
        UpdateTool(id, values.name, values.totalTool, values.status, imageFile).then(res => {
            if (res.status === 201) {
                console.log(res)
                notification.success({
                    message: "Update Tool Successfully"
                })
                setLoading(false);
                setEdit(false)
            }
        }).catch(err => {
            console.log(err)
            notification.error({
                message: `${err.response.data.message}`
            })
            setLoading(false);
        })
    }


    return (
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>
            <div style={{ maxWidth: 800, margin: 'auto', padding: '24' }}>

                <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                    Tool
                </Title>
                {Edit ? (
                    <Form
                        onFinish={onFinish}
                        form={form}
                    >
                        <Card title="Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                            <Form.Item
                                name="image"
                                label="Image"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => {
                                    if (Array.isArray(e)) {
                                        return e;
                                    }
                                    return e?.fileList;
                                }}
                            >
                                <Upload
                                    listType="picture-card"
                                    maxCount={1}
                                    beforeUpload={() => false} // Prevent auto upload
                                    accept="image/*"
                                >
                                    <div>
                                        <PlusOutlined />
                                        <div style={{ marginTop: 8 }}>Upload</div>
                                    </div>
                                </Upload>
                            </Form.Item>
                            <Form.Item name={"name"} label="Name" rules={[{ required: true, message: 'Requiring name' }]}>
                                <Input
                                    placeholder="Input Name"
                                />
                            </Form.Item>
                            <Form.Item name={"totalTool"} label="Total Tool" rules={[{ required: true, message: 'Requiring total tool' }]}>
                                <Input
                                    placeholder="Input Total Tool"
                                />
                            </Form.Item>
                            <Form.Item name={"status"} label="Status"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Requiring status',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Choose status"
                                >
                                    <Option key="1" value="Active">
                                        Active
                                    </Option>
                                    <Option key="2" value="InActive">
                                        InActive
                                    </Option>
                                    <Option key="3" value="UnderPrepair">
                                        UnderPrepair
                                    </Option>

                                </Select>
                            </Form.Item>
                        </Card>

                        <Form.Item>
                            <Button block type="primary" htmlType="submit" loading={loading}>
                                {loading ? "Loading" : "Confirm Update"}
                            </Button>
                        </Form.Item>
                    </Form>
                ) : (
                    <>
                        <Form
                            form={form}
                            name="wrap"
                            labelAlign="left"
                            labelWrap
                            labelCol={{ flex: '150px' }}
                        >
                            <Card title="Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                <Form.Item
                                    name="image"
                                    label="Image"
                                    valuePropName="fileList"
                                    getValueFromEvent={(e) => {
                                        if (Array.isArray(e)) {
                                            return e;
                                        }
                                        return e?.fileList;
                                    }}
                                >
                                    <Upload
                                        listType="picture-card"
                                        maxCount={1}
                                        beforeUpload={() => false} // Prevent auto upload
                                        accept="image/*"
                                    >
                                        <div>
                                            <PlusOutlined />
                                            <div style={{ marginTop: 8 }}>Upload</div>
                                        </div>
                                    </Upload>
                                </Form.Item>
                                <Form.Item name={"name"} label={<span style={{ fontSize: '16px' }}>Name</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <Input
                                        disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item name={"totalTool"} label={<span style={{ fontSize: '16px' }}>Total Tool</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <Input
                                        disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item name={"status"} label={<span style={{ fontSize: '16px' }}>Status</span>}

                                >
                                    <Input
                                        disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                    />
                                </Form.Item>
                            </Card>
                        </Form>
                        <div style={{ marginTop: 5, marginBottom: 16 }}>
                            <Button block type="primary" onClick={() => setEdit(true)}>
                                Update Tool
                            </Button>
                        </div>
                    </>
                )}

            </div>
        </div>

    )

}
export default AdminDetailTool